import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {SlotModel} from '@app/@core/domain/slot.model';
import Slot = SlotModel.Slot;

interface SlotVM {
    off: boolean;
    color: string;
    enableHotDeal: boolean;
    startDate: Date;
    discountPrice: number |  string;
    persons: number | string;
    flashDeal: boolean;
}

@Component({
    selector: 'app-slot-cell',
    template: `
        <ng-container *ngIf="item">
            <div style="position: relative">

                <div class="border-round bg-{{item.color}}-300 p-1 m-1 cursor-pointer" style="width:70px;">
                    <div class="flex flex-column gap-1">
                        <div
                            class="flex align-items-center justify-content-center border-round-top mt-2 bg-{{item.color}}-400">
                            <span class="text-white" [class.line-through]="item.off">
                                {{item.startDate | date:'HH:mm'}}
                            </span>
                        </div>
                        <div
                            class="flex align-items-center justify-content-center text-200 border-round-bottom font-light bg-{{item.color}}-500">
                            <small [class.hot-deal]="item.enableHotDeal">
                                {{(item.discountPrice) | number}}
                            </small>
                            <i *ngIf="item.flashDeal" class="pi pi-bolt text-yellow-500"></i>

                        </div>
                    </div>
                </div>
                <div *ngIf="item.persons" class="badge-top-right">
                    <p-badge [value]="item.persons" styleClass="white-badge"></p-badge>
                </div>
            </div>
        </ng-container>
    `,
    styles: [
        `
            .badge-top-right {
                position: absolute;
                top: 1px;
                right: 2px;
            }
            .hot-deal {
                text-decoration: underline;
                text-decoration-color: red;
                text-decoration-thickness: 2px;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotCellComponent implements OnChanges {
    @Input()
    slot: Slot;

    item: SlotVM;

    private static getColor(slot: Slot) {
        if (slot.status === 'CLOSE') {
            // return 'purple';
            return 'bluegray';
        } else if (slot.status === 'PAID') {
            return 'green';
        } else if (slot.status === 'HIDE') {
            return 'gray';
        }

        if (slot.priceCategory === 'NORMAL') {
            return 'blue';
        } else if (slot.priceCategory === 'SPECIAL') {
            return 'orange';
        } else if (slot.priceCategory === 'HOTDEAL') {
            return slot.specialPrice ? 'red' : 'pink';
        } else {
            return 'blue';
        }
    }

    private static isOff(slot: SlotModel.Slot) {
        return slot.available === 0 || slot.status === 'CLOSE' || slot.status === 'HIDE';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.slot) {
            this.item = {
                startDate: this.slot.startDate,
                discountPrice: this.slot.discountPrice ?? this.slot.priceRule.price1,
                color: SlotCellComponent.getColor(this.slot),
                enableHotDeal: this.slot.enableHotDeal,
                flashDeal: this.slot.flashDeal,
                off: SlotCellComponent.isOff(this.slot),
                persons: this.slot.persons
            };
        } else {
            this.item = null;
        }
    }
}
